<template>
  <el-select
    v-model="groupId"
    style="vertical-align: top;width:100%"
    placeholder="请选择人员职称">
    <el-option
      v-for="item in list"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
</template>
<script>
import Common from '@/service/common'
export default {
  name: 'ExpertCareerSelect',
  props: {
    value: { required: true }
  },
  data() {
    return { list: [] }
  },
  computed: {
    groupId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      Common.getkeyvaluebykey({ topic: 'sgs', k: 'work' })
        .then(res => {
          const { result, message, v } = res.data
          if ([0].includes(result)) {
            this.list = JSON.parse(v)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
